<input
  type="text"
  id="{{ 'question-input-' + question.id }}"
  [formControl]="myFormControl"
  hidden
  class="hidden"
/>
<input
  #inputEl
  type="file"
  class="hidden"
  accept=".png,.jpeg,.jpg,.heic"
  (change)="initFile($event.target['files'])"
  [attr.tabindex]="tabIndex"
/>
<div class="image-field-actions">
  <div
    class="ui primary button"
    [class]="{ disabled: disabled }"
    (click)="inputEl.click()"
  >
    {{ "upload-image" | transloco }}
  </div>
  @if (imageUrl) {
  <div>
    <div
      class="ui button"
      (click)="removeImage()"
      [class]="{ disabled: lockOnlyDisabledValue }"
    >
      {{ "remove-image" | transloco }}
    </div>
  </div>
  }
</div>
@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question.question }} {{ "is-required" | transloco }}</div>
  }
</div>
} @if (fileStatus === 'Uploading') {
<div>
  {{ "uploading-image" | transloco }}
  <i class="inline circle notch icon loading"></i>
</div>
} @if (!!errorMessage) {
<div class="clear validation-text">
  {{ errorMessage }}
</div>
} @if (loadingImage) {
<div>
  {{ "loading-image-preview" | transloco }}
  <i class="inline circle notch icon loading"></i>
</div>
} @if (imageUrl) {
<div>
  <div
    class="image-field-preview"
    [style]="{ 'max-width': imageMaxWidth, 'max-height': imageMaxHeight }"
  >
    <img
      [src]="imageUrl"
      [style]="{
        'object-fit': 'contain',
        width: imageMaxWidth,
        height: imageMaxHeight
      }"
    />
  </div>
</div>
}
